// Recovered compiled webpack factory 94781. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "warnOnce", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
  let r = (e) => {};
}
